
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiFolderCheckOutline,
	// mdiRunFast,
	mdiAccountWrench,
	mdiAccountDetails,
	mdiViewDashboard,
	mdiAvTimer,
	mdiAccountAlert,
	mdiBusDoubleDecker,
	// mdiGithub,
	// mdiMonitorShimmer,
	mdiOfficeBuilding,
	mdiAccountConvert,
	mdiCalendar,
	mdiSoccer,
	mdiQrcodeScan,
	mdiAccountSchool,
	mdiCog,
	mdiAccount,
	mdiSchool,
	// mdiExclamationThick,
	// mdiPencilOff,
	mdiComment,
	mdiGoogleClassroom,
	mdiBookshelf,
	mdiCashMultiple,
	mdiFlag,
	mdiCalendarAccount,
	mdiAccountChild,
	mdiDoorOpen,
	mdiNeedle,
	mdiArrowUpBold,
	mdiAccountOutline,
	mdiAccountCircle,
	mdiBookOpenVariant,
	// mdiHammerScrewdriver,
	mdiFaceAgent,
	// mdiFormatListBulletedType,
	// mdiFormatLetterMatches,
	// mdiNumeric9BoxMultiple,
	mdiAccountGroup,
	mdiCalendarCursor,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	// mdiBookOpenPageVariant,
	// mdiBookPlusMultiple,
	// mdiNotebookEdit,
	mdiPuzzle,
	// mdiFileDocument,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiTimetable,
	mdiCalendarMonth,
	mdiBookOpenPageVariant,
	// mdiBookEducationOutline,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	// mdiCurrencyUsd,
	mdiNotebookEdit,
	mdiNumeric9BoxMultiple,
	// mdiPuzzle,
	mdiTimelineClockOutline,
	mdiWatermark,
	// mdiComment,
	// mdiAccountCheckOutline,
	// mdiInformationOutline,
	// mdiAccountMultiple,
	mdiAccountMultiplePlus,
	// mdiSetAll,
	mdiPen,
	mdiChartBar
	// mdiTagMultiple,
	// mdiViewModule,
	// mdiTrophyOutline
	// mdiAccountTie,
	// mdiAccountStar,
	// mdiOfficeBuildingCogOutline,
	// mdiCity,
	// mdiSofa
	// mdiAccountCash
} from '@mdi/js'
// const roles = localStorage.getItem('roles')

// const menuTeacher = [
// 	'General',
// 		[
// 			{
// 				to: '/comboard-dashboard',
// 				icon: mdiViewDashboard,
// 				label: 'sidebar.dashboard'
// 			}
// 		],
// 		'Examples',
// 		[
// 			{
// 				label: 'Attendance',
// 				subLabel: 'Submenus Attendance',
// 				icon: mdiAccountArrowLeft,
// 				menu: [
// 					{
// 						to: '/attendancelist',
// 						label: 'Regular Subject',
// 						icon: mdiAccountArrowLeftOutline
// 					},
// 					{
// 						to: '/attendancestreaming',
// 						label: 'Parallel Subject',
// 						icon: mdiAccountArrowLeftOutline
// 					},
// 					{
// 						to: '/reportattendancedaily',
// 						label: 'Daily Attendance Report',
// 						icon: mdiAccountAlert
// 					}
// 				]
// 			}
// 		]
// ]

const menuAcademicAll = [
	'General',
		[
			{
				to: '/comboard-dashboard',
				icon: mdiViewDashboard,
				label: 'sidebar.dashboard'
			}
		],
	'Examples',
		[
			{
				label: 'Master',
				subLabel: 'Submenus Master',
				icon: mdiCog,
				menu: [
					{
						to: '/academicyear',
						label: 'Academic Year',
						icon: mdiCalendar
					},
					{
						to: '/financialyear',
						label: 'Financial Year',
						icon: mdiCalendarMonth
					},
					{
						to: '/academicbatch',
						label: 'Academic Batch',
						icon: mdiCalendarAccount
					},
					{
						to: '/department',
						label: 'Department',
						icon: mdiOfficeBuilding
					},
					{
						to: '/semester',
						label: 'Semester',
						icon: mdiFlag
					},
					{
						to: '/level',
						label: 'Level',
						icon: mdiArrowUpBold
					},
					{
						to: '/resignationreason',
						label: 'Resignation Reason',
						icon: mdiBookOpenVariant
					},
					{
						to: '/class',
						label: 'Class',
						icon: mdiGoogleClassroom,
						updateMark: true
					},
					{
					  to: '/workunit',
					  label: 'Work Unit',
					  icon: mdiOfficeBuilding,
					  updateMark: true
					},
					{
					  to: '/shift',
					  label: 'Shift',
					  icon: mdiAccountConvert,
					  updateMark: true
					},
					// {
					// 	to: '/extracuricular',
					// 	label: 'Extracuricular',
					// 	icon: mdiSoccer
					// },
					{
						to: '/vaccines',
						label: 'Vaccines',
						icon: mdiNeedle
					},
					{
						to: '/comment',
						label: 'Comment',
						icon: mdiComment
					},
					{
						to: '/regisbatch',
						label: 'Registration Batch',
						icon: mdiCalendarCursor
					},
					{
						to: '/major',
						label: 'Major',
						icon: mdiSchool
					},
					{
						to: '/major-date',
						label: 'Event',
						icon: mdiSchool
					}
				]
			},

			// {
			// 	label: 'Course Achievement',
			// 	to: '/coursework-achievement',
			// 	icon: mdiTrophyOutline
			// },
			// {
			// 	label: 'Master Course',
			// 	subLabel: 'Coursework Master',
			// 	icon: mdiViewModule,
			// 	menu: [
			// 		{
			// 			to: '/coursework',
			// 			label: 'Coursework',
			// 			icon: mdiBookEducationOutline
			// 		},
			// 		{
			// 			to: '/price-group',
			// 			label: 'Price Group',
			// 			icon: mdiTagMultiple
			// 		},
			// 		{
			// 			to: '/price-list',
			// 			label: 'Price List',
			// 			icon: mdiCurrencyUsd
			// 		},
			// 		{
			// 			to: '/non-academic-activity',
			// 			label: 'Non Academic Activity',
			// 			icon: mdiRunFast
			// 		}
			// 	]
			// },
			// {
			// 	label: 'Comboard',
			// 	subLabel: 'Submenus Comboard',
			// 	icon: mdiComment
			// },
			{
				label: 'Candidates',
				subLabel: 'Submenus Candidates',
				icon: mdiAccountChild,
				menu: [
					{
						to: '/newbatchregistration',
						label: 'New Batch Registration',
						icon: mdiDoorOpen
					},
					{
						to: '/candidatesgroup',
						label: 'Candidates Group',
						icon: mdiAccountOutline
					},
					{
						to: '/candidate',
						label: 'Candidate',
						icon: mdiAccountOutline
					},
					// {
					// 	to: '/candidate-doc',
					// 	label: 'Candidate Documents',
					// 	icon: mdiAccountGroup
					// },
					{
						to: '/placement',
						label: 'Candidates Placement',
						icon: mdiAccountOutline
					}
				]
			},
			{
				label: 'Student',
				subLabel: 'Submenus Student',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/students',
						label: 'Students Data',
						icon: mdiAccountGroup
					},
					// {
					// 	to: '/student-doc',
					// 	label: 'Student Documents',
					// 	icon: mdiAccountGroup
					// },
					// {
					// 	to: '/parentuser',
					// 	label: 'Parents',
					// 	icon: mdiAccount
					// },
					// {
					// 	to: '/',
					// 	label: 'Users',
					// 	icon: mdiAccountMultiple
					// },
					{
						to: '/class-transfer',
						label: 'Class Transfer',
						icon: mdiAccountMultiplePlus
					},
					{
						to: '/studentresignation',
						label: 'Resignation',
						icon: mdiAccountGroup
					},
					{
						to: '/graduation',
						label: 'Graduation',
						icon: mdiAccountSchool
					}
				]
			},
			{
				label: 'Parents',
				to: '/parentuser',
				icon: mdiAccount
			},
			// {
			// 	label: 'Generate',
			// 	to: '/generate-userid',
			// 	icon: mdiAccountCircle
			// },
			{
				label: 'Employee',
				subLabel: 'Employee',
				icon: mdiAccountCircle,
				menu: [
					{
						to: '/employee',
						label: 'Employees',
						icon: mdiAccount
					}
				]
			},
			{
				label: 'Subject',
				subLabel: 'Submenus Subject',
				icon: mdiBookOpenVariant,
				menu: [
					{
						to: '/subject',
						label: 'Subject',
						icon: mdiBookshelf
					},
					{
						to: '/subjectgroup',
						label: 'Subject Group',
						icon: mdiBookOpenPageVariant
					},
					{
						to: '/learningmethod',
						label: 'Learning Method',
						icon: mdiBookPlusMultiple
					},
					{
						to: '/gradingmaster',
						label: 'Grading Master',
						icon: mdiHammerScrewdriver
					},
					{
						to: '/gradingaspects',
						label: 'Grading Aspects',
						icon: mdiHammerScrewdriver
					},
					{
						to: '/assignmenttype',
						label: 'Assignment Type',
						icon: mdiFormatListBulletedType
					},
					{
						to: '/grading-rule',
						label: 'Grading Criteria',
						icon: mdiFormatLetterMatches
					},
					{
						to: '/finalscorerule',
						label: 'Final Score Rule',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/scoreminimum',
						label: 'Passing Grade',
						icon: mdiNumeric9BoxMultiple
					},
					{
						to: '/syllabus',
						label: 'Syllabus',
						icon: mdiNotebookEdit
					},
					{
						to: '/teaching-time-plan',
						label: 'Teaching Timeplan',
						icon: mdiTimelineClockOutline
					},
					{
						to: '/lessonplan',
						label: 'Lesson Plan',
						icon: mdiPuzzle
					},
					{
						to: '/studentparalelsubject',
						label: 'Student Parallel Subject',
						icon: mdiAccountDetails
					},
					{
						to: '/studentselectsubject',
						label: 'Student Subject Selection',
						icon: mdiAccountDetails
					}
				]
			},
			{
				label: 'Extracuricular',
				subLabel: 'Submenus Extracuricular',
				icon: mdiSoccer,
				menu: [
					{
						to: '/extracuricular',
						label: 'Extracuricular',
						icon: mdiSoccer
					},
					{
						to: '/extracuriculagroup',
						label: 'Extracuricular Group',
						icon: mdiSoccer
					},
					{
						to: '/extracuricularstudent',
						label: 'Student Extracuricular',
						icon: mdiAccountDetails
					},
					{
						to: '/extracuricularstudentselect',
						label: 'Student Extracuricular Selection',
						icon: mdiAccountDetails
					}
					// {
					// 	to: '/extracuricularbarchart',
					// 	label: 'Report Extracuricular',
					// 	icon: mdiAccountDetails
					// }
				]
			},
			{
				label: 'Teacher',
				subLabel: 'Submenus Teacher',
				icon: mdiClipboardAccount,
				menu: [
					{
						to: '/teacher',
						label: 'Teacher',
						icon: mdiClipboardAccountOutline
					},
					{
						to: '/teacherextracuricular',
						label: 'Extracurricular Teacher',
						icon: mdiSoccer
					},
					{
						to: '/scanasset',
						label: 'Scan Asset',
						icon: mdiQrcodeScan
					},
					{
						to: '/scanassetlocation',
						label: 'Scan Asset Location',
						icon: mdiQrcodeScan
					}
					// {
					// 	to: '/teacherjournal',
					// 	label: 'Teacher Journal',
					// 	icon: mdiFileDocument
					// }
				]
			},
			{
				label: 'Roles',
				subLabel: 'Roles',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/role',
						label: 'Role',
						icon: mdiFaceAgent
					},
					{
						to: '/role-group',
						label: 'Role Group',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Transaction',
				subLabel: 'Transaction',
				icon: mdiCashMultiple,
				menu: [
					{
						to: '/transaction-type',
						label: 'Transaction Type',
						icon: mdiCashMultiple
					},
					{
						to: '/transaction-group',
						label: 'Transaction Group',
						icon: mdiCashMultiple
					}
				]
			},
			// {
			// 	label: 'Incomes',
			// 	subLabel: 'Payment',
			// 	icon: mdiAccountCash,
			// 	menu: [
			// 		{
			// 			to: '/paymenttransaction',
			// 			label: 'Payment',
			// 			icon: mdiCashMultiple
			// 		},
			// 		{
			// 			to: '/income',
			// 			label: 'Income',
			// 			icon: mdiCashMultiple
			// 		}
			// 	]
			// },
			{
				label: 'Permission Request',
				subLabel: 'Submenus Teacher',
				icon: mdiFaceAgent,
				menu: [
					{
						to: '/permissions',
						label: 'Permissions',
						icon: mdiFaceAgent
					},
         			{
						to: '/permission-reason',
						label: 'Permission Reason',
						icon: mdiFaceAgent
					}
				]
			},
			{
				label: 'Schedule',
				subLabel: 'Submenus Schedule',
				icon: mdiTimetable,
				menu: [
						{
						to: '/schooltime',
						label: 'School Time',
						icon: mdiAvTimer
					},
					{
						to: '/studytime',
						label: 'Study Time',
						icon: mdiAvTimer
					},
					{
						to: '/schedule',
						label: 'Schedule',
						icon: mdiTimetable
					},
					{
						to: '/eskulschedule',
						label: 'Extracuricular Schedule',
						icon: mdiTimetable
					},
					{
						to: '/calendar',
						label: 'Calendar',
						icon: mdiCalendarMonth
					}
				]
			},
			{
				label: 'School Events',
				to: '/listschoolevents',
				icon: mdiCalendar
			},
			{
				label: 'Attendance',
				subLabel: 'Submenus Attendance',
				icon: mdiAccountArrowLeft,
				menu: [
					{
						to: '/attendancelist',
						label: 'Regular Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/attendancestreaming',
						label: 'Parallel Subject',
						icon: mdiAccountArrowLeftOutline
					},
					{
						to: '/reportattendancedaily',
						label: 'Daily Attendance Report',
						icon: mdiAccountAlert
					},
					{
						to: '/summary-report',
						label: 'Summary Report',
						icon: mdiAccountAlert
					},
					{
						to: '/assignment-special',
						label: 'Special Assignment',
						icon: mdiBusDoubleDecker
					}
				]
			},
			{
				label: 'Subject Assessment',
				subLabel: 'Submenus Subject Assessment',
				icon: mdiSchool,
				menu: [
					{
						to: '/lesson-assessment-regular',
						label: 'Regular',
						icon: mdiSchool
					},
					{
						to: '/lesson-assessment-parallel',
						label: 'Parallel',
						icon: mdiSchool
					},
					{
						to: '/ledger-homeroom-teacher',
						label: 'Homeroom Ledger',
						icon: mdiSchool
					},
					{
						to: '/extracuricular-score',
						label: 'Extracuricular Score',
						icon: mdiSchool
					}
				]
			},
			{
				label: 'Raport',
				to: '/student-raport',
				icon: mdiSchool
			},
			{
				label: 'Settings',
				subLabel: 'Submenus Settings',
				icon: mdiCog,
				menu: [
					{
						to: '/schoolidentity',
						label: 'School Identity',
						icon: mdiSchool
					},
					{
						to: '/branch',
						label: 'Branch',
						icon: mdiWatermark
					},
					{
						to: '/users',
						label: 'Users',
						icon: mdiAccount
					},
					{
						to: '/active-docmag',
						label: 'Activate Management',
						icon: mdiFolderCheckOutline
					},
					{
						to: '/unapprove-mechanism',
						label: 'Unapprove Mechanism',
						icon: mdiAccountWrench
					},
					{
						to: '/settingattendance',
						label: 'Setting Attendance',
						icon: mdiPen
					},
					{
						to: '/settingspeed',
						label: 'Chart & Analysis Setting',
						icon: mdiChartBar
					},
					{
						to: '/settingtimeout',
						label: 'Setting Major & Cross Major',
						icon: mdiTimelineClockOutline
					},
					{
						to: '/settingextracuricular',
						label: 'Setting Extracuricular',
						icon: mdiTimelineClockOutline
					},
					{
						to: '/settingmodule',
						label: 'Setting Module',
						icon: mdiBookOpenPageVariant
					},
					{
						to: '/template-announcement',
						label: 'Template Announcement',
						icon: mdiSchool
					}
				]
			}
		]
]
export default menuAcademicAll
